/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";

import { events } from "@nuskin/ns-util";
import template from "./ns-login-modal.html";

/**
 * The ns-login-modal
 * <h1>Login</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-login-modal></ns-login-modal>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsLoginModal extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-login-modal";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      hidden: {
        type: Boolean,
        value: false
      },
      edit: {
        type: Boolean,
        value: false
      },
      submitLabel: {
        type: String,
        value: "Submit"
      },
      cancelLabel: {
        type: String,
        value: "Cancel"
      },
      loginLabel: {
        type: String,
        value: "Login"
      },
      username: {
        type: String,
        value: ""
      },
      password: {
        type: String,
        value: ""
      },
      that: {
        type: Object,
        value: () => this
      }
    };
  }

  ready() {
    super.ready();
    let that = this;
    aem.gigyaService.initialize(null, null);
    events.subscribe(events.authentication.REQUEST_FOR_LOGIN_MODAL, function(
      object
    ) {
      that.$.dialog.open();
    });
  }

  processLogin() {
    this.silentLogin();
  }

  closeDialog() {
    this.$.dialog.close();
  }

  openDialog() {
    this.$.dialog.open();
  }

  modalLoginCallback(eventObj) {
    this.closeDialog();
  }

  silentLogin() {
    gigya.accounts.login({
      loginID: this.username,
      password: this.password,
      format: "jsonp",
      callback: this.modalLoginCallback.bind(this)
    });
  }
}
customElements.define(NsLoginModal.is, NsLoginModal);
